import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Overlay from "../../SharedComponents/Overlay";
import IconSvg from "../../SharedComponents/IconSvg";
import { login } from "../Store/AuthThunk";
import { useDispatch, useSelector } from "react-redux";

export function HashLogin() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userAtRedux = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (!hash) {
      alert("Bozuk link, lütfen mailde size gönderilen kullanıcı bilgileri ile giriş yapınız");
      navigate("/login");
      return;
    }

    let loginData;
    try {
      const correctedHash = hash.replace(/-/g, "+").replace(/_/g, "/");
      loginData = JSON.parse(atob(correctedHash));
    } catch (e) {
      alert("Bozuk link, lütfen mailde size gönderilen kullanıcı bilgileri ile giriş yapınız");
      navigate("/login");
      return;
    }

    dispatch(login(loginData)).then((result) => {
      if (!login.fulfilled.match(result)) {
        alert(result.payload || "Giriş başarısız, lütfen mailde size gönderilen bilgiler ile giriş yapınız");
        navigate("/login");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  useEffect(() => {
    if (userAtRedux?.userRole) {
      localStorage.setItem("cpdata", JSON.stringify(userAtRedux));
      if (userAtRedux.userRole === "Admin") navigate("/dash");
      else if (userAtRedux.userRole === "User") navigate("/userdash");
    }
  }, [userAtRedux]);

  return (
    <div style={{ marginTop: "100px", display: "flex", justifyContent: "center" }}>
      <Overlay text="Hoşgeldiniz, Yönlendirme yapılıyor" />
      <IconSvg icon="cp-logo" height="100" width="100" />
    </div>
  );
}
